import React from 'react'
import styles from './result-info.css'


function ResultInfo({ localizedName, newArtist, headlineArtists, venueName, venueCity, eventListingsText }) {
    return (
        <section className={styles['wrapper']}>
            <h3 className={styles["eventname"]} data-ln="EventsListDetailsName">
                <span className={styles["localizedname"]}>{localizedName}</span>
                {newArtist && <span className={styles["new"]}>{newArtist}</span>}
            </h3>
            <h4 className={styles["headliners"]} data-ln="EventsListDetailsHeadliners">{headlineArtists}</h4>
            <h4 className={styles["venue"]} data-ln="EventsListDetailsVenueName">{venueName}</h4>
            <h5 className={styles["city"]} data-ln="EventsListDetailsVenueCity">{venueCity}</h5>
            {eventListingsText && <p className={styles["freetext"]}>{eventListingsText}</p>}
        </section>
    )
}

export default ResultInfo